import { createCacheStore } from '@lib/utils/cache';
import { DepartmentService } from '@api/DepartmentService';

/** Cached DepartmentService.getDepartment(departmentId, params?) reads. */
export const departmentCache = createCacheStore(
    'department/department',
    DepartmentService.getDepartment,
);

/** Cached DepartmentService.getOrgDepartments(orgId) reads. */
export const orgDepartmentsCache = createCacheStore(
    'department/orgDepartments',
    DepartmentService.getOrgDepartments,
);

/** Drops all cached department data (department switch, full clears). */
export const invalidateDepartmentData = (): void => {
    departmentCache.invalidateAll();
    orgDepartmentsCache.invalidateAll();
};
